// Schedule-FE marks inactive events with status DEACTIVATED and describes why in deactivatedData.action.
// Legacy records were deactivated before the action was recorded, so they only report the status.
const INACTIVE_ACTIONS = ['CANCELLED', 'DELETED', 'RESCHEDULED'];

const isInactiveEvent = (event) => {
  return event?.status === 'DEACTIVATED';
};

const getInactiveEventAction = (event) => {
  if (!isInactiveEvent(event)) {
    return null;
  }

  const action = event.deactivatedData?.action;

  return INACTIVE_ACTIONS.includes(action) ? action : 'INACTIVE';
};

export {
  isInactiveEvent,
  getInactiveEventAction,
};
